import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../../models/base/base-component';
import { BaseDisplay } from '../../../../../models/display/dto/base-display';
import { of, Subject } from 'rxjs';
import { delay, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { ModalConfirmation } from '../../../../../modals/modal-confirmation';
import { ConfirmationOptions } from '../../../../../models/shared/stylesheet/confirmation-options';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonType } from '../../../../../models/enum/shared/button-type';

@Component({
  selector: 'app-edit-display-details',
  templateUrl: './edit-display-details.component.html',
  styleUrls: ['./edit-display-details.component.scss', '../../../../shared/styles/edit-page-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditDisplayDetailsComponent extends BaseComponent {
  constructor(
    private readonly ngbModal: NgbModal,
    private readonly injector: Injector
  ) {
    super();
  }

  @Input() display: BaseDisplay;
  @Input() mergeKey: string;
  @Output() copyDisplayUrl = new EventEmitter();
  @Output() refreshDisplay = new EventEmitter<string>();

  public readonly _refreshingDisplay = new Subject<void>();
  public readonly refreshingDisplay$ = this._refreshingDisplay.pipe(
    switchMap(() => of(false).pipe(delay(5000), startWith(true))),
    startWith(false),
    distinctUntilChanged()
  );

  reloadDisplayClicked(): void {
    const opts = new ConfirmationOptions();
    opts.title = 'Confirm Reload Display';
    opts.bodyText =
      `Are you sure you want to reload the display? This will send a signal to the device and trigger` +
      ` the display to refresh immediately.`;
    opts.cancelText = 'Cancel';
    opts.continueText = 'Reload';
    opts.continueButtonType = ButtonType.Primary;
    const confirmed = (cont: boolean) => {
      if (cont) {
        this._refreshingDisplay.next();
        this.refreshDisplay.emit(this.display.id);
      }
    };
    ModalConfirmation.open$(this.ngbModal, this.injector, opts, confirmed);
  }
}
